var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.hasMetaproperties
      ? _c(
          "div",
          { staticClass: "metaproperties-table" },
          [
            _c("b-table", {
              attrs: {
                items: _vm.metapropertiesItems,
                stacked: "sm",
                borderless: "",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }